import styled from 'styled-components/macro';
import { Modal } from 'ui-component-library/components';
import { FlexAlignRight } from '../../../../../shared-styles/flex';

export const StyledModal = styled(Modal)`

`;

export const EmailContent = styled.div`
  font-family: ${({ theme }) => theme.typography.fonts.default};
  font-size: 12px;
  box-sizing: border-box;
  width: 100%;
  height: ${({ height }) => height};
  resize: none;
  outline: none;
  margin-top: 8px;
  white-space: pre-wrap;
`;

export const ErrorMessage = styled.div`
  color: ${(props) => props.theme.palette.red[100]};
  font-size: ${(props) => props.theme.typography.sizes.small};
  margin-bottom: ${(props) => props.theme.spacing(15)};
`;

export const ButtonWrapper = styled.div`
  height: 40px;
  margin-top: ${(props) => props.theme.spacing(10)};
  ${FlexAlignRight}
  button:not(:first-child) {
    margin-left: ${(props) => props.theme.spacing(15)};
  }
`;

export const TextAreaContainer = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(5)};
`;

export const EmailContentLabel = styled.div`
  font-size: ${(props) => props.theme.typography.sizes.small};
  line-height: 19px;
  margin-bottom: 0;
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
  color: ${(props) => props.theme.palette.darkBlue[100]};
`;
